<!--- COMPONENTE UCSupplementaryData  ---->
<!--
Descripción del componente:
---------------------------
- Incluye una lista con los datos complementarios de la entidad.

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->

<template>
  <div>
    <div>
      <!-- Preloader de carga -->
      <UCPreload
        :show="mostrarPrecarga"
        :number="1"
      />

      <!-- Documentos Adjuntos -->
      <div class="content-data-list padding">
        <div class="grid-3 content-data-list__title">
          <div>
            {{ $t('common.code') }}
          </div>
          <div>
            {{ $t('common.name') }}
          </div>
          <div>
            {{ $t('common.value') }}
          </div>
        </div>
        <div
          v-for="dc in datosComplementarios"
          :key="dc.Id"
          class="grid-3 content-data-list__data"
        >
          <div v-if="dc.Codigo !== ''">
            {{ FormatearCadena(dc.Codigo, 25) }}
          </div>
          <div v-if="dc.Nombre !== ''">
            {{ FormatearCadena(dc.Nombre, 25) }}
          </div>
          <div v-if="dc.Valor !== ''">
            {{ FormatearCadena(dc.Valor, 25) }}
          </div>
        </div>
      </div> <!-- Fin registro -->
      <span v-if="datosComplementarios.length === 0 && !mostrarPrecarga">
        {{ $t('supplementaryData.noData') }}
      </span>
    </div>
  </div>
</template>

<script>
import ConexionTA from '@/js/services/traceability/APITraceability';
import SoporteCadena from '@/js/common/HiChainSupport';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { HiNotification } from '@/js/common/HINotificationSupport';
import UCPreload from './UCPreload.vue';

export default {
  name: 'UCSupplementaryData',
  components: {
    UCPreload,
  },
  props: {
    entidadSeleccionada: {
      type: Object,
      default: null,
    },
    tipoEntidadSeleccionada: {
      type: String,
      default: '',
    },
    activo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      datosComplementarios: [],
      mostrarPrecarga: false, // Controla si se muestra el componente de precarga.
    };
  },
  watch: {
    entidadSeleccionada(newVal, oldVal) { // watch it
      if (!this.activo) {
        return;
      }
      if (newVal != null) {
        this.ObtenerDatosComplementariosEntidadSeleccionada();
      }
      if (newVal === null && oldVal != null) {
        this.RestablecerComponente();
      }
    },
    activo() { // watch it
      // if (val) { this.InicializarComponente(); }
    },

  },
  created() {
    this.InicializarComponente();
    this.ObtenerDatosComplementariosEntidadSeleccionada();
  },

  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      if (this.entidadSeleccionada != null && this.activo) {
        this.ObtenerDatosComplementariosEntidadSeleccionada();
      }
    },

    RestablecerComponente() {
      Log(this, this.RestablecerComponente.name);
      this.datosComplementarios = [];
    },
    /** @public */
    Actualizar() {
      Log(this, this.Actualizar.name);
      this.RestablecerComponente();
      if (this.entidadSeleccionada != null) {
        this.ObtenerDatosComplementariosEntidadSeleccionada();
      }
    },

    FormatearCadena(cadena, longitudMaxima) {
      Log(this, this.FormatearCadena.name);
      if (cadena == null) {
        return '';
      }
      return SoporteCadena.TextoLogitudMaxima(cadena, longitudMaxima);
    },

    ObtenerDatosComplementariosEntidadSeleccionada() {
      Log(this, this.ObtenerDatosComplementariosEntidadSeleccionada.name);
      const self = this;
      self.mostrarPrecarga = true;
      ConexionTA.callObtenerDatosComplementariosEntidadSeleccionada(this.entidadSeleccionada.Id, this.tipoEntidadSeleccionada).then((result) => {
        if (result.Valor) {
          self.datosComplementarios = JSON.parse(result.Mensaje);
          self.mostrarPrecarga = false;
        } else {
          self.mostrarPrecarga = false;
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch(() => {
          self.mostrarPrecarga = false;
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError('error');
        });
    },
  },
};
</script>

<style lang="scss">
.content-data-list {
  &__title {
    color: var(--his-oliva);
    font-size: 14px;
    font-weight: 500;
  }

  &__data {
    color: var(--his-steel-blue);
    font-size: 16px;
    font-weight: 500;
    padding-top: 5px;
  }

  .grid-3 {
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    grid-column-gap: 10px;
  }
}
</style>
